// სალაროს შემოსავალი
import React, { CSSProperties } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { formValueSelector } from 'redux-form'
import { Tab } from 'semantic-ui-react'
import moment from 'moment'
import isEqual from 'lodash/isEqual'
import { isInvalid, touch, getFormSyncErrors } from 'redux-form'
import IconPreloader from 'loankeeper-common/components/IconPreloader'
import { translate } from 'loankeeper-common/helpers'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import { beforeEntryAddEdit, view as eventView } from '../../../store/event'
import LKModal, { actions as LKModalActions } from '../../shared/LKModal'
import ClientValidationResults from '../../shared/Modals/ClientValidationResults'
import { withLivedata } from '../../shared'
import MainTab from './MainTab'
import ClientDetailsTabView from '../partials/ClientDetailsTabView'
import UccTabView from './UccTabView'
import AuthorizeUnAuthorizeButton from '../shared/AuthorizeUnAuthorizeButton'
import AuthorizeCheckbox from '../shared/AuthorizeCheckbox'
import AddAndOpenAgainButton from '../shared/AddAndOpenAgainButton'
import Header from './Header'
import { markResubmit } from './addContainers'
import { translateLKMessage } from '../translate'
import { maskForRequiredFields } from '../constants'
import { accEntryViewUCC } from 'src/store/accEntry'
import { AccEntryViewUCCParams, CashInOutModalProps, apiParamsData } from './CashInOut.types'

const valueSelector = formValueSelector('CashDepositAdd')

@withRouter
//@ts-ignore
@connect(
  (state) => ({
    isInvalid: isInvalid('CashDepositAdd')(state),
    errors: getFormSyncErrors('CashDepositAdd')(state),
    isClientSelected: valueSelector(state, 'clientIsChosen'),
    MoneyTransferSystemID: valueSelector(state, 'MoneyTransferSystemID'),
    dob: valueSelector(state, 'DOB'),
    amount: valueSelector(state, 'Amount'),
    clientID: valueSelector(state, 'clientID'),
    clientHash: valueSelector(state, 'clientHash'),
    Name: valueSelector(state, 'Name'),
    Surname: valueSelector(state, 'Surname'),
    Name_ALT: valueSelector(state, 'Name_ALT'),
    Surname_ALT: valueSelector(state, 'Surname_ALT'),
    CellPhone: valueSelector(state, 'CellPhone'),
    clientType: valueSelector(state, 'clientType'),
    DocDate: valueSelector(state, 'DocDate'),
    CCYValue: valueSelector(state, 'CCY'),
    OperTypeID: valueSelector(state, 'OperTypeID'),
    chosenAccountTypeID: valueSelector(state, 'chosenAccountTypeID'),
    MoneyTransferCountryID: valueSelector(state, 'MoneyTransferCountryID'),
    moneytransfer_agent: valueSelector(state, 'moneytransfer_agent'),
    DebitAccID: valueSelector(state, 'DebitAccID'),
    DebitAccHash: valueSelector(state, 'DebitAccHash'),
    CreditAccID: valueSelector(state, 'CreditAccID'),
    CreditAccHash: valueSelector(state, 'CreditAccHash'),
    IDDoc: valueSelector(state, 'IDDoc'),
    CardNumber: valueSelector(state, 'CardNumber'),
  }),

  {
    openInfo: LKModalActions.openInfo,
    openModal: LKModalActions.open,
    accEntryViewUCC: (params: AccEntryViewUCCParams) => accEntryViewUCC(params),
    openMatrixWarningConfirmation: () =>
      LKModalActions.openConfirmation('CONFIRM_MATRIX_WARNING', {
        message: translate('LKMESSAGE-CONFIRM_VALIDATION_WARNING_OVERRIDE'),
        //@ts-ignore
        code: 'CONFIRM_VALIDATION_WARNING_OVERRIDE',
      }),
    openError: LKModalActions.openError,
    touchFormFields: touch,
    beforeEntryAddEdit,
    eventView,
  },
)
//@ts-ignore
@withLivedata('OpenDayStatus.Open_Day_Str as openDayStr')
class CashInOutModal extends React.Component<CashInOutModalProps> {
  isDobModalOpen = false

  delayedModal = null

  session: {
    WHLSessionID?: number
    ErrorLevel?: number
    HashSum_WHLSessionID_?: string
  } = {}

  eventParams = {}

  eventData = undefined

  state = {
    uccViewData: null,
    verifying: false,
    action: this.props.initialValues.action,
  }

  componentDidMount() {
    // register required fields.
    // without registering, validation will not check these fields !!
    Object.keys(this.props.requiredFields).forEach((key) => {
      this.props.register(this.props.form, maskForRequiredFields[key], 'Field')
    })

    this.props.register(this.props.form, 'CreditAccNo', 'Field')
    this.props.register(this.props.form, 'DebitAccNo', 'Field')
    this.props.register(this.props.form, 'Amount', 'Field')
    this.props.register(this.props.form, 'DocDate', 'Field')
    this.props.register(this.props.form, 'CardNumber', 'Field')
  }

  handleOpenModal = (modalParams) => {
    this.props.openModal(modalParams || this.delayedModal)
  }

  handleOpenConfirmModal = (modal) => {
    if (this.isDobModalOpen) {
      this.delayedModal = modal
    } else {
      this.handleOpenModal(modal)
    }
  }

  handleOpenDobModal = () => {
    this.isDobModalOpen = true
    this.props.openModal({
      name: 'DobConfirmationModal',
      message: `${this.props.openDayStr}: ${translate('LKMESSAGE-MSG_REMIND_CLIENT_DOB')}`,
      code: 'MSG_REMIND_CLIENT_DOB',
    })
  }

  getModalHeading = () => {
    let heading = translate('frm_acc_entry_add-frm_acc_entry_add')

    const { params } = this.props

    if (params && params.ID && params.OID) {
      heading = `${heading}: ID - ${params.ID}, OID - ${params.OID}`
    }

    return heading
  }

  clientIsInWatchList = (dob: boolean) => {
    if (this.props.clientWatched) {
      this.handleOpenConfirmModal({
        name: 'ClientWatchedConfirmation',
        message: `${translate('LKMESSAGE-CONFIRM_VALIDATION_WARNING_OVERRIDE')}`,
        code: 'CONFIRM_VALIDATION_WARNING_OVERRIDE',
        customHtml: `
          ${dob && this.props.isClientSelected ? `<p>${translate('LKMESSAGE-MSG_REMIND_CLIENT_DOB')}</p>` : ''}
          <p>${translate('LKMESSAGE-ERR_CLIENT_WATCHED')}</p>
        `,
      })

      return true
    }

    if (dob && this.props.isClientSelected) {
      this.handleOpenConfirmModal({
        name: 'ClientWatchedConfirmation',
        message: `${translate('LKMESSAGE-CONFIRM_VALIDATION_WARNING_OVERRIDE')}`,
        code: 'CONFIRM_VALIDATION_WARNING_OVERRIDE',
      })

      return true
    }

    return false
  }

  submitAndOpenAgain = () => {
    const dob = this.checkIfTodayIsBirthday()
    this.props.change('OpenAgain', true)
    if (!this.clientIsInWatchList(dob)) {
      setTimeout(this.props.submit, 0)
    }
  }

  checkIfTodayIsBirthday = () => {
    const dob = !!(
      moment(this.props.dob, 'DD.MM.YYYY').format('M') === moment(this.props.OpenDay, 'DD.MM.YYYY').format('M') &&
      moment(this.props.dob, 'DD.MM.YYYY').format('D') === moment(this.props.OpenDay, 'DD.MM.YYYY').format('D')
    )

    if (dob && this.props.isClientSelected) {
      this.handleOpenDobModal()
    }

    return dob
  }

  submitAndClearOpenAgainFlag = () => {
    const dob = this.checkIfTodayIsBirthday()

    this.props.change('OpenAgain', false)
    if (!this.clientIsInWatchList(dob)) {
      setTimeout(this.props.submit, 0)
    }
  }

  fetchUccView = () =>
    new Promise(async (resolve) => {
      const accResult = await this.props.accEntryViewUCC({
        EntryID: this.props.params.ID,
        HashSum_EntryID_: this.props.params.hash,
        OID: this.props.mainTabData.OID,
        HashSum_OID_: this.props.mainTabData.HashSum_OID_,
      })

      if (accEntryViewUCC.fulfilled.match(accResult)) {
        resolve(accResult.payload)
      }
    }).then(({ payload }) => {
      this.setState({ uccViewData: payload })
      return Promise.resolve(payload)
    })

  onVerify = () => {
    if (this.props.isInvalid) {
      this.props.touchFormFields('CashDepositAdd', ...Object.keys(this.props.errors))
      this.props.openError(translateLKMessage('ERR_FILL_REQUIRED_FIELDS'))
      return
    }

    const {
      amount,
      clientID,
      clientHash,
      Name,
      Surname,
      Name_ALT,
      Surname_ALT,
      CellPhone,
      clientType,
      CCYValue,
      DocDate,
      isClientSelected,
      OperTypeID,
      chosenAccountTypeID,
      MoneyTransferCountryID,
      moneytransfer_agent,
      DebitAccID,
      DebitAccHash,
      CreditAccID,
      CreditAccHash,
      IDDoc,
      MoneyTransferSystemID,
      CardNumber,
    } = this.props

    let AMLOperTypeID

    if (OperTypeID === 3) {
      AMLOperTypeID = chosenAccountTypeID === 9 ? 70 : 40
    } else {
      AMLOperTypeID = chosenAccountTypeID === 9 ? 80 : 50
    }

    const apiParams: apiParamsData = {
      SP_ACT: this.state.action === 'add' ? 0 : 1,
      AMLOperTypeID,
      Amount: amount,
      CCY: CCYValue,
      OperDate: DocDate,
      ClientType: clientType,
      OperTypeID,
      DebitAccID,
      HashSum_DebitAccID_: DebitAccHash,
      CreditAccID,
      HashSum_CreditAccID_: CreditAccHash,
      IDDocID: IDDoc && IDDoc.ID,
      HashSum_IDDocID_: IDDoc && IDDoc.HashSum_IDDocID_,
      PersonalNo: CardNumber,
    }

    if (isClientSelected) {
      apiParams.ClientID = clientID
      apiParams.HashSum_ClientID_ = clientHash
    } else {
      apiParams.Name = Name
      apiParams.Surname = Surname
      apiParams.Name_ALT = Name_ALT
      apiParams.Surname_ALT = Surname_ALT
      apiParams.CellPhone = CellPhone
    }

    if (chosenAccountTypeID === 9) {
      apiParams.MoneyTransferCountryID = MoneyTransferCountryID
      apiParams.MoneyTransferAgent = moneytransfer_agent
      apiParams.MoneyTransferSystemID = MoneyTransferSystemID
    }

    if (this.session.WHLSessionID && isEqual(this.eventParams, apiParams)) {
      this.props.openModal({
        name: 'ClientValidationResults',
        Data: this.eventData,
        ErrorLevel: this.session.ErrorLevel,
      })
      return
    }

    if ((OperTypeID === 3 || OperTypeID === 4) && clientType === 0) {
      apiParams.ClientType = 1
    }

    this.setState({ verifying: true })

    this.props
      .beforeEntryAddEdit(apiParams)
      .then((result) => {
        const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = result.payload

        this.session = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }
        this.eventParams = apiParams

        return this.props.eventView({ WHLSessionID, HashSum_WHLSessionID_ }).then((eventResult) => {
          //@ts-ignore
          if (!eventView.fulfilled.match(eventResult)) {
            return
          }

          const Data = eventResult.payload

          this.eventData = Data

          this.props.openModal({ name: 'ClientValidationResults', Data, ErrorLevel })
        })
      })
      .catch((e) => {
        this.props.openError(translateLKMessage((e.Error && (e.Error.Message || e.Error.Text)) || 'HINT_ERR_TITLE'))
      })
      .finally(() => {
        this.setState({ verifying: false })
      })
  }

  render() {
    const {
      name,
      CCY,
      OpCode,
      CashAccounts,
      change,
      clearFields,
      submitting,
      clientSelects,
      form,
      requiredFields,
      MoneyTransferSystem,
      OpenDay,
      CurrentDay,
      cashOut = false,
      mainTabData,
      onAuthorize,
      initialValues,
      permissions,
      uccViewData,
      detailsTabData,
    } = this.props

    const params = this.props.params || {}
    const { verifying } = this.state

    return (
      <>
        <ClientValidationResults
          name="ClientValidationResultsConfirm"
          onClose={this.props.openMatrixWarningConfirmation}
        />

        {/* @ts-ignore */}
        <LKModal.Confirmation
          name="CONFIRM_MATRIX_WARNING"
          onConfirm={() => {
            markResubmit()
            this.submitAndClearOpenAgainFlag()
          }}
        />

        {/* @ts-ignore */}
        <LKModal.Confirmation name="ClientWatchedConfirmation" onConfirm={() => this.props.submit()} />
        {/* @ts-ignore */}
        <LKModal.Dob name="DobConfirmationModal" onConfirm={this.handleOpenModal} />
        {/* @ts-ignore */}
        <LKModal
          name={name}
          icon={cashOut ? 'entries_cashout' : 'entries_cashin'}
          heading={this.getModalHeading()}
          size="medium"
          footer={
            //@ts-ignore
            <LKModal.Footer
              actions={
                //@ts-ignore
                params.authorizing ? (
                  <AuthorizeUnAuthorizeButton
                    action={this.props.params.action}
                    data={mainTabData}
                    onAuthorize={onAuthorize}
                    name={name}
                    details={{
                      OperTypeID: mainTabData.OperTypeID,
                      OID: mainTabData.OID,
                      HashSum_EntryID_: mainTabData.HashSum_EntryID_,
                      HashSum_OID_: mainTabData.HashSum_OID_,
                      EntryID: mainTabData.ID,
                    }}
                  />
                ) : (
                  <AuthorizeCheckbox FormName={form} />
                )
              }
              sideActions={
                //@ts-ignore
                params.authorizing ? (
                  //@ts-ignore
                  <LKModal.CancelButton
                    disabled={submitting}
                    loading={submitting}
                    text={translate('frm_acc_entry_add-cmd_close')}
                  />
                ) : (
                  <>
                    <LKBaseButton
                      alias="amlCheckmark"
                      loading={verifying}
                      disabled={verifying}
                      onClick={this.onVerify}
                    />
                    <AddAndOpenAgainButton FormName={form} submitting={submitting} onClick={this.submitAndOpenAgain} />
                    <LKBaseButton.Okay
                      //@ts-ignore
                      style={{ width: 85, marginRight: 0 } as CSSProperties}
                      disabled={submitting}
                      loading={submitting}
                      onClick={this.submitAndClearOpenAgainFlag}
                    />
                  </>
                )
              }
            />
          }
          fullBody
        >
          <Header
            heading={
              cashOut
                ? translate('frm_acc_entry_add-lbl_ot_cash_expense')
                : translate('frm_acc_entry_add-lbl_ot_cash_income')
            }
            name={name}
            form={form}
          />

          <Tab
            panes={[
              {
                menuItem: translate('frm_acc_entry_add-tb_1'),
                render: () => (
                  <MainTab
                    //@ts-ignore
                    ID={params.ID}
                    //@ts-ignore
                    hash={params.hash}
                    CCY={CCY}
                    OpCodes={OpCode}
                    cashOut={cashOut}
                    change={change}
                    clearFields={clearFields}
                    CashAccounts={CashAccounts}
                    //@ts-ignore
                    disableInputs={params.authorizing}
                    form={form}
                  />
                ),
              },

              {
                menuItem: translate('frm_acc_entry_add-tb_2'),
                render: () => (
                  <ClientDetailsTabView
                    change={change}
                    form={form}
                    requiredFields={requiredFields}
                    clientSelects={clientSelects}
                    OpenDay={OpenDay}
                    CurrentDay={CurrentDay}
                    //@ts-ignore
                    disableInputs={params.authorizing}
                    cashOut={cashOut}
                    MoneyTransferSystem={MoneyTransferSystem}
                    clearFields={clearFields}
                    //@ts-ignore
                    customChange={this.handleDobChange}
                    initialValues={initialValues}
                    permissions={permissions}
                    detailsTabData={detailsTabData}
                  />
                ),
              },

              ...(mainTabData && mainTabData.UCCEntry === 1
                ? [
                    {
                      menuItem: translate('frm_acc_entry_add-tb_ucc'),
                      render: () => (
                        <UccTabView
                          //@ts-ignore
                          mainTabData={mainTabData}
                          uccViewData={this.state.uccViewData || uccViewData}
                          fetchUccView={this.fetchUccView}
                        />
                      ),
                    },
                  ]
                : []),
            ]}
          />

          <IconPreloader collection="account" />
        </LKModal>
      </>
    )
  }
}

//@ts-ignore
CashInOutModal.defaultProps = {
  requiredFields: {},
}

export default CashInOutModal
